import offersTypes from "./offersTypes";

const initialState = {
    pending: false,
    offers: [],
    currentOffer: null,
    communities: [],
    communitiesPending: false,
    totalOffers: 0,
};

const offersReducer = (state = initialState, action) => {
    switch (action.type) {
        // Get offers list
        case offersTypes.GET_OFFERS_LIST_PENDING:
            return { ...state, pending: true };
        case offersTypes.GET_OFFERS_LIST_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: action.payload || [],
                totalOffers: action.payload?.length || 0
            };
        case offersTypes.GET_OFFERS_LIST_ERROR:
            return { ...state, pending: false };

        // Create offer
        case offersTypes.CREATE_OFFER_PENDING:
            return { ...state, pending: true };
        case offersTypes.CREATE_OFFER_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: [action.payload, ...state.offers]
            };
        case offersTypes.CREATE_OFFER_ERROR:
            return { ...state, pending: false };

        // Get communities
        case offersTypes.GET_COMMUNITIES_PENDING:
            return { ...state, communitiesPending: true };
        case offersTypes.GET_COMMUNITIES_SUCCESS:
            return {
                ...state,
                communitiesPending: false,
                communities: action.payload || []
            };
        case offersTypes.GET_COMMUNITIES_ERROR:
            return { ...state, communitiesPending: false };

        // Update offer
        case offersTypes.UPDATE_OFFER_PENDING:
            return { ...state, pending: true };
        case offersTypes.UPDATE_OFFER_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: state.offers.map(offer =>
                    offer.id === action.payload.id ? action.payload : offer
                ),
                currentOffer: action.payload
            };
        case offersTypes.UPDATE_OFFER_ERROR:
            return { ...state, pending: false };

        // Delete offer
        case offersTypes.DELETE_OFFER_PENDING:
            return { ...state, pending: true };
        case offersTypes.DELETE_OFFER_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: state.offers.filter(offer => offer.id !== action.payload)
            };
        case offersTypes.DELETE_OFFER_ERROR:
            return { ...state, pending: false };

        // Get offer details
        case offersTypes.GET_OFFER_DETAILS_PENDING:
            return { ...state, pending: true };
        case offersTypes.GET_OFFER_DETAILS_SUCCESS:
            return {
                ...state,
                pending: false,
                currentOffer: action.payload
            };
        case offersTypes.GET_OFFER_DETAILS_ERROR:
            return { ...state, pending: false };

        // Clear current offer
        case offersTypes.CLEAR_CURRENT_OFFER:
            return { ...state, currentOffer: null };

        // Activate offer
        case offersTypes.ACTIVATE_OFFER_PENDING:
            return { ...state, pending: true };
        case offersTypes.ACTIVATE_OFFER_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: state.offers.map(offer =>
                    offer.id === action.payload.id ? action.payload : offer
                )
            };
        case offersTypes.ACTIVATE_OFFER_ERROR:
            return { ...state, pending: false };

        // Suspend offer
        case offersTypes.SUSPEND_OFFER_PENDING:
            return { ...state, pending: true };
        case offersTypes.SUSPEND_OFFER_SUCCESS:
            return {
                ...state,
                pending: false,
                offers: state.offers.map(offer =>
                    offer.id === action.payload.id ? action.payload : offer
                )
            };
        case offersTypes.SUSPEND_OFFER_ERROR:
            return { ...state, pending: false };

        default:
            return state;
    }
};

export default offersReducer;
